import { ApiConfig } from "../../Config/ApiConfig";
import {createPostDataAction } from "./CommonAction";
import { BOOKINGLIST , BOOKINGDETAIL } from "../../Constants/BookingConstants";

export const BookingGetAction = (payload:any) => createPostDataAction(BOOKINGLIST, ApiConfig?.BookingList,payload,false);
export const BookingDetailAction = (payload:any) => createPostDataAction(BOOKINGDETAIL, ApiConfig?.BookingDetail,payload,false);
